import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { loadAnalytics, trackPageView } from "@/lib/analytics";

export const CONSENT_KEY = "nutrimove-consent";

// Banner consenso cookie: nessun cookie non tecnico prima della scelta.
export default function CookieConsent() {
  const [choice, setChoice] = useState(() => {
    try {
      return localStorage.getItem(CONSENT_KEY);
    } catch {
      return "rejected";
    }
  });

  useEffect(() => {
    if (choice === "accepted") {
      loadAnalytics();
    }
  }, [choice]);

  const choose = (value) => {
    try {
      localStorage.setItem(CONSENT_KEY, value);
    } catch {
      /* storage non disponibile */
    }
    setChoice(value);
    if (value === "accepted") {
      trackPageView(window.location.pathname);
    }
  };

  return (
    <AnimatePresence>
      {choice === null && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-consent-banner"
          role="dialog"
          aria-label="Preferenze sui cookie"
          className="fixed inset-x-4 bottom-24 z-50 sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-md"
        >
          <div className="grain relative overflow-hidden rounded-2xl border border-white/10 bg-ink p-6 text-white shadow-2xl shadow-black/25">
            <p className="font-display text-lg tracking-tight">Rispettiamo la tua privacy</p>
            <p className="mt-2 text-xs leading-relaxed text-white/60">
              Questo sito usa solo cookie tecnici e, previo tuo consenso, strumenti di analisi per
              migliorare l'esperienza. Leggi la{" "}
              <Link to="/privacy-policy" className="underline underline-offset-2 transition-colors hover:text-leaf">
                Privacy Policy
              </Link>{" "}
              e la{" "}
              <Link to="/cookie-policy" className="underline underline-offset-2 transition-colors hover:text-leaf">
                Cookie Policy
              </Link>
              .
            </p>
            <div className="mt-5 flex gap-3">
              <button
                type="button"
                onClick={() => choose("accepted")}
                data-testid="cookie-accept-button"
                className="flex-1 rounded-full bg-leaf px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-ink transition-colors duration-200 hover:bg-white"
              >
                Accetta
              </button>
              <button
                type="button"
                onClick={() => choose("rejected")}
                data-testid="cookie-reject-button"
                className="flex-1 rounded-full border border-white/25 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-white transition-colors duration-200 hover:border-leaf hover:text-leaf"
              >
                Rifiuta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
